<template>
    <section class="people-box">
        <section class="people-box-data-wrapper">
            <input type="checkbox" @change="checkedPeople()" v-model="checked" class="checkboxForMessage" v-tooltip="$t('com.file.people.designation-sms-email-send')" />
            <section class="people-box__profile-wrapper">
                <img :src="avatarToUpdate"
                     class="people-box-data-wrapper__profile-pic" />
                <section class="people-box__edit-icon" v-if="adminMenagePrivilige && adminContactPrivilige" @click="addFile()" v-tooltip="$t('com.file.people.change-avatar')" style="width: 14px;">
                    <img src="../../../../../assets/icons/components/pen.svg" />
                </section>
                <section class="people-box__delete-icon" v-if="adminMenagePrivilige && adminContactPrivilige" @click="deleteAvatar()" v-tooltip="$t('com.file.people.delete-avatar')">
                    <img src="../../../../../assets/icons/components/exit-red.svg" style="width: 14px;" />
                </section>
            </section>

            
        <span class="people-box-data-wrapper__text people-box-data-wrapper__text--bold">
            <section class="d-flex flex-row align-items-center gap-2">
                <PulseDot :color="getOnlineColor" v-tooltip="getOnlineStatusTooltip" />
                <section>
                    <p>{{ name }} {{ lastName }}</p> 
                    <span style="font-size: 11px; font-weight: 400;">(ID: {{id}})</span>
                    <span v-if="adminMainPrivilige && canManageTwoFactor" class="people-box__two-factor-status">
                        {{ $t(twoFactorStatusKey) }}
                    </span>
                </section>
            </section>

        </span>
            <span class=" people-box-data-wrapper__text people-box-data-wrapper__text--mail">{{ mail }}</span>
            <span class="people-box-data-wrapper__text">{{ number }}</span>
        </section>
        <ButtonGroup class="people-box-action-wrapper" :label="`${name} ${lastName}`">
            <section class="people-box-action-wrapper__on-hover">
                <ButtonWithIconContacts class="contact-box-custom-button contact-box-custom-button--two-factor"
                    v-if="adminMainPrivilige && canManageTwoFactor" type="button" icon="lock" text="2FA"
                    v-tooltip="$t('com.file.contacts.two-factor-title')" @click="showTwoFactorModal = true" />
                <ButtonOnlyWithIcon class="contact-box-custom-button" v-if="isInUserTable && isSupportCalendarIntegration" icon="download-black" @click="downloadCalendar()" v-tooltip="$t('com.file.people.download-user-calendar')"/>
                <ButtonOnlyWithIcon class="contact-box-custom-button" v-if="isInUserTable && isSupportCalendarIntegration" icon="callendar" @click="copyCalendarLink()" v-tooltip="$t('com.file.people.copy-user-calendar-link')"/>
                <ButtonOnlyWithIcon class="contact-box-custom-button" v-if="adminMenagePrivilige && isInUserTable && isQrCodeLogin != null && isQrCodeLogin == true" icon="qrcode" @click="() => showQrCode()" v-tooltip="$t('com.file.people.qr-code')"/>
                <ButtonOnlyWithIcon class="contact-box-custom-button" v-if="number.length > 0" icon="send-sms" @click="() => sendSmsHandler( 1, null, this.id, null)" v-tooltip="$t('com.file.sms.send-sms-messages')"/>
                <ButtonOnlyWithIcon class="contact-box-custom-button" v-if="mail.length > 0" icon="send-mail" @click="() => sendEmailHandler(1, null, this.id, null)" v-tooltip="$t('com.file.people.send-email')" />
                <ButtonOnlyWithIcon class="contact-box-custom-button" v-if="adminMainPrivilige && adminMenagePrivilige" icon="lock" @click="() => handlePermissionClick(this.id)" v-tooltip="$t('com.file.people.priviliges')"/>
                <ButtonOnlyWithIcon class="contact-box-custom-button" v-if="adminMenagePrivilige && portalMieszkanca == 1" icon="tooltip" @click="() => publicInfoHndler(id, name, lastName)" v-tooltip="$t('com.file.people.public-data')" />
            </section>
            <ButtonOnlyWithIcon class="contact-box-custom-button" icon="edit" v-if="adminMenagePrivilige" @click="() => addContactHandler(null, 'add-contact', { id: id, action: 'edit-contact',})" v-tooltip="$t('com.file.people.edit-contact')"/>
            <ButtonOnlyWithIcon class="contact-box-custom-button" v-if="!isInUserTable && adminMenagePrivilige" icon="delete" @click="() => handleDeleteClick(this.id)" v-tooltip="$t('com.file.people.delete-contact')"/>

        </ButtonGroup>
        <PermissionModal v-if="showPermissionModal && adminMainPrivilige && adminMenagePrivilige" @closePermission="closePermissionModal" :permission="permission" :lid="tempLid" />
        <PersonTwoFactorModal v-if="showTwoFactorModal && adminMainPrivilige && canManageTwoFactor" :personId="id" :personName="`${name} ${lastName}`"
            @close="showTwoFactorModal = false" @changed="(value) => $emit('twoFactorChanged', value)" />
        <PublicInfoModal v-if="portalMieszkanca == 1 && showPublicInfoModal && adminMenagePrivilige" @closePublicInfo="closePublicInfo" :publicInfo="publicInfo" :lid="tempLid" :personName="tempName" />
        <ImageDialog v-if="showImageModal" :imgContent="imgContent" @imguser-update="imageUpdate" @closeImageModal="closeImageModal"></ImageDialog>
        <QrCodeModal v-if="showQRcodeModal" :qrcode="qrcode" :name="name" :lastName="lastName" @closeQrCodeModal="closeQrCodeModal"></QrCodeModal>
    </section>
</template>

<script charset="utf-8">
import ContactService from "../../../../../services/contact.service";
import { encryptStorage } from '../../../../../services/encrypt.service';
import ImageDialog from "../Modals/AddContact/ImageModal.vue";
import QrCodeModal from "../Modals/AddContact/QrCodeModal.vue";
import PermissionModal from "../Modals/AddContact/AddPermission.vue";
import PersonTwoFactorModal from "../Modals/PersonTwoFactorModal.vue";
import { twoFactorStatusKey } from "@/helpers/two-factor.helper";
import PublicInfoModal from "../Modals/AddContact/PublicInfoModal.vue";
import ButtonOnlyWithIcon from "../../../../BasicControls/ButtonOnlyWithIcon.vue";
import ButtonWithIconContacts from "../../../../BasicControls/ButtonWithIconContacts.vue";
import ButtonGroup from "@/components/BasicControls/Buttons/ButtonGroup.vue";
import CommonHelper from '@/helpers/common.helper.js';
import PulseDot from "../../../../BasicControls/PulseDot.vue";
import { copyToClipboard } from "../../../../../helpers/utils";
import { fileDownloadHelper } from "../../../../../helpers/file.download.helper";

export default {
    name: "People",
    props: {
        name: String,
        lastName: String,
        mail: String,
        number: String,
        id: Number,
        addContactHandler: Function,
        onlineStatus: Number,
        isLocked: Boolean,
        isInUserTable: Boolean,
        avatar: String,
        sendSmsHandler: Function,
        sendEmailHandler: Function,
        isQrCodeLogin: Boolean,
        calendarLink: String,
        twoFactor: { type: Object, default: null },
    },
    components: {
        ButtonOnlyWithIcon,
        ButtonWithIconContacts,
        ButtonGroup,
        PersonTwoFactorModal,
        PermissionModal,
        ImageDialog,
        PublicInfoModal,
        QrCodeModal,
        PulseDot
    },
    computed:{
        twoFactorStatusKey() {
            return twoFactorStatusKey(this.twoFactor);
        },
        // Only accounts that can actually sign in to the eSesja admin panel can use 2FA.
        canManageTwoFactor() {
            return this.twoFactor?.canManage === true;
        },
        isAnyModalOpen(){
                return this.showPermissionModal
                    || this.showPublicInfoModal
                    || this.showImageModal
                    || this.showQRcodeModal
                    || this.showTwoFactorModal
            },
        getOnlineStatusTooltip(){
            switch(this.onlineStatus){
                case 10: return this.$t('com.file.people.not-active-user');
                case 30: return this.$t('com.file.people.online-user');
                default: return this.$t('com.file.people.offline-user');
            }
        },
        getOnlineColor(){
            switch(this.onlineStatus){
                case 10: return "orange";
                case 30: return "green";
                default: return "red";
            }
        },
        isSupportCalendarIntegration(){
            return this.$store.state.settings.runtime.supportCalendarIntegration;
        }
    },
    data() {
        return {
            showPermissionModal: false,
            showTwoFactorModal: false,
            showPublicInfoModal: false,
            publicInfo: {},
            permission: {},
            tempName: '',
            adminContactPrivilige: encryptStorage.getItem("priv").komunikator,
            adminMainPrivilige: encryptStorage.getItem("priv").uprawnienia,
            adminMenagePrivilige: encryptStorage.getItem("priv").zarzadzanie_kontaktami,
            portalMieszkanca: encryptStorage.getItem('modules').pm,
            tempLid: 0,
            imgContent: '',
            showImageModal: false,
            showQRcodeModal: false,
            avatarToUpdate: this.avatar,
            checked: false,
            qrcode: '',
            unknownAvatar: require('@/assets/imgs/unknown.png'),
        }
    },
    watch: {
        '$store.state.contacts.sendMessageSuccess': {
            deep: true,
            handler: function () {
                if (this.$route.name === "contact") {
                    this.checked = false;
                    this.$store.commit('setSendMessageSuccess', false);
                }
            }
        },
        '$store.state.contacts.selectedPeopleToSendMessage': {
            deep: true,
            handler: function (nevValue) {
                if (this.$route.name === "contact") {
                    if (nevValue.includes(this.id)) {
                        this.checked = true;
                    }
                    else {
                        this.checked = false;
                    }
                }
            }
        },
        isAnyModalOpen: {
                deep: true,
                handler: function (val) {
                    document.querySelector('body').style.overflow = val ? 'hidden' : 'auto';
                }
            },
    },
    mounted() {
        const storeList = this.$store.state.contacts.selectedPeopleToSendMessage;
        if (storeList.includes(this.id)) {
            this.checked = true;
        }

    },
    methods: {
        checkedPeople() {
            var data = {
                checked: this.checked,
                id: this.id
            };

            this.$emit("checkedPeopleForMessage", data);
        },
        showQrCode() {
            this.$store.commit('showLoader');

            ContactService.getUserQrCodeForLogin(this.id).then((response) => {

                if (response.status == 200) {
                    this.qrcode = response.data;
                    this.showQRcodeModal = true;
                } else {
                    this.qrcode = '';
                    this.showQRcodeModal = false;
                }
                
            }).catch((e) => {
                console.log(e);
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            }).finally(() => {
                this.$store.commit('hideLoader');
            });
        },
        closeQrCodeModal() {
            this.qrcode = '';
            this.showQRcodeModal = false;
        },
        async imageUpdate(value) {
            if (value.length <= 0) {
                this.imgContent = '';
            }
            else
            {
                this.imgContent = '';

                try {
                    var t = { image: value, userId: this.id };
                    var res = (await ContactService.prepareImageToSend(t)).data;

                    if (res == true) {
                        this.avatarToUpdate = "https://ssl.esesja.pl/users/" + this.id + ".jpg" + CommonHelper.getRandomVersionImageForUrlRefresh(0, 100);
                    }
                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }

                this.showImageModal = false;
            }
        },
        closeImageModal() {
            this.showImageModal = false;
        },
        openImageDialog() {
            this.showImageModal = true;
        },
        async deleteAvatar() {
            const actionToFire = async () => {
                await this.imageUpdate(this.unknownAvatar);
            };
            this.$store.commit("showConfirmationAlert", actionToFire);
        },
        addFile() {
            if (this.adminMenagePrivilige && this.adminContactPrivilige) {
                let input = document.createElement('input');
                input.type = 'file';
                input.accept = '.jpg,.jpeg';
                input.multiple = false;
                input.click();
                var thisVue = this;
                input.addEventListener('change', (event) => {
                    if (event.target.files[0].size <= 10000000) {
                        if (this.checkMimeType(event.target.files[0].type)) {
                            var reader = new FileReader();
                            reader.readAsDataURL(event.target.files[0]);
                            reader.onload = function (e) {
                                thisVue.imgContent = e.target.result;
                                thisVue.openImageDialog();
                            }
                        }
                        else {
                            alert(this.$t('com.validation-error.invalid-file-type-info') +" JPG,JPEG")
                        }
                    } else {
                        alert(this.$t('com.validation-error.invalid-file-size-info') + " 10MB");
                    }
                });
            }
        },
        checkMimeType(type) {
            if (type != "image/jpeg" && type != "image/jpg" /*&& type != "image/png"*/) {
                return false;
            } else {
                return true;
            }
        },
        handleDeleteClick(id) {
            const actionToFire = () => {
                this.$store.state.userStore.isLoading = true;
                ContactService.deleteContact(id).then(() => {
                    var d = this.$store.state.appStore.groups;
                    for (var i = 0; i < d.length; i++) {
                        var people = d[i].people;
                        if (people.length > 0) {
                            var index = people.findIndex(x => x.id == id);
                            if (index != -1) {
                                people.splice(index, 1);
                            }
                        }
                    }
                    this.$store.state.userStore.isLoading = false;
                    this.$emit("reloadGroups", d);
                });
            };
            this.$store.commit("showConfirmationAlert", actionToFire);
        },
        async publicInfoHndler(id, name, lastname) {
            try {
                this.$store.commit('showLoader');
                var result = (await ContactService.getPublicUserInfo(id)).data;
                if (Object.keys(result).length > 0) {
                    this.publicInfo = result;
                    this.tempLid = id;
                    this.tempName = name + " " + lastname;
                    this.showPublicInfoModal = true;
                }
            } catch (e) {
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            }
            finally{
                this.$store.commit('hideLoader');
            }
        },
        async handlePermissionClick(id) {
            try {
                this.$store.commit('showLoader');
                var result = (await ContactService.getUserDataToEdit(id)).data;
                if (Object.keys(result).length > 0) {
                    this.permission = result;
                    this.tempLid = id;
                    this.showPermissionModal = true;
                }
            } catch (e) {
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            }
            finally{
                this.$store.commit('hideLoader');
            }
        },
        closePermissionModal() {
            this.showPermissionModal = false;
            this.tempLid = 0;
            this.permission = {};
            this.$emit("reloadGroups", this.$store.state.appStore.groups);
        },
        closePublicInfo() {
            this.showPublicInfoModal = false;
            this.tempLid = 0;
            this.publicInfo = {};
            this.tempName = '';
        },
        async copyCalendarLink(){
            try{
                await copyToClipboard(this.calendarLink);
                this.$store.commit("showSuccessCustomMessage", this.$t('com.file.people.copy-calendar-to-clipboard'));
            }
            catch{
                this.$store.commit("showError");
            }
        },
        async downloadCalendar(){
            try{
                this.$store.commit("showLoader");
                let response = await ContactService.downloadUserCalendar(this.calendarLink);
                if(response.status !== 200){
                    throw await Promise.reject(response);
                }

                fileDownloadHelper(response);
                this.$store.commit("showSuccessCustomMessage", this.$t('com.file.people.download-calendar-success'));
            }
            catch{
                this.$store.commit("showError");
            }
            finally{
                this.$store.commit("hideLoader");
            }
        }
    },
};
</script>

<style lang="scss" scoped>

    .people-box__two-factor-status {
        display: block;
        font-size: 11px;
        font-weight: 500;
        margin-top: 4px;
    }

    .checkboxForMessage {
        margin-right: 10px;
        cursor: pointer;
    }

    input[type=checkbox] {
        transform: scale(1.5);
    }

    .people-box-data-wrapper {
        display: flex;
        align-items: center;

        &__text {
            font-weight: 500;
            font-size: 14px;
            line-height: 145%;
            color: #00082c;

            &--bold {
                font-weight: 600;
                width: 248px;
                margin-left: 10px;
                position: relative;

                @media only screen and (max-width: 1600px) {
                    width: 158px;
                }
            }

            &--active {
                &::after {
                    content: "";
                    position: absolute;
                    left: -20px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 8px;
                    height: 8px;
                    background: #60a800;
                    box-shadow: 1px 2px 4px rgba(65, 114, 0, 0.16);
                    border-radius: 100%;
                }
            }

            &--unactive {
                &::after {
                    content: "";
                    position: absolute;
                    left: -20px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 8px;
                    height: 8px;
                    background: #ffb800;
                    box-shadow: 1px 2px 4px rgba(65, 114, 0, 0.16);
                    border-radius: 100%;
                }
            }

            &--mail {
                width: 371px;
                text-overflow: ellipsis;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                padding-right: 10px;

                @media only screen and (max-width: 1600px) {
                    width: 300px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                }
            }
        }

        &__profile-pic {
            width: 35px;
            height: 35px;
            vertical-align: middle;
            border-radius: 50%;
        }
    }

    .people-box {
        padding: 14px 16px;
        background: #ffffff;
        border: 1px solid #dce4ee;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
        border-radius: 12px;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:hover .people-box-action-wrapper__on-hover {
            display: flex;
        }

        &:hover .people-box-action-wrapper:has(> .people-box-action-wrapper__on-hover > .contact-box-custom-button) {
            > .people-box-action-wrapper__on-hover ~ .contact-box-custom-button:first-of-type {
                border-top-left-radius: 0 !important;
                border-bottom-left-radius: 0 !important;
            }
        }

        &__profile-wrapper {
            position: relative;
        }

        &__edit-icon {
            position: absolute;
            top: 25px;
            left: -8px;
            width: 16px;
            height: 16px;
            background-color: #e8ecf2;
            border: 2px solid white;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }

        &__delete-icon {
            position: absolute;
            top: 25px;
            left: 20px;
            width: 16px;
            height: 16px;
            background-color: #e8ecf2;
            border: 2px solid white;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }

        &__lock-icon {
            position: absolute;
            top: -8px;
            left: -10px;
            width: 22px;
            height: 22px;
            background-color: #e8ecf2;
            border: 2px solid white;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

.people-box-action-wrapper {
    display: flex;
    flex-wrap: nowrap;

    &__on-hover {
        display: none;
        transition: all 0.3s ease-in-out;
        .contact-box-custom-button{

            &:first-of-type{
                border-top-left-radius: 4px !important;
                border-bottom-left-radius: 4px !important;
            }
        }
    }

    &:has(> .people-box-action-wrapper__on-hover ~ .contact-box-custom-button) {
        .people-box-action-wrapper__on-hover .contact-box-custom-button:last-of-type {
            border-right: none !important;
            border-top-right-radius: 0px !important;
            border-bottom-right-radius: 0px !important;
        }
    }

    .contact-box-custom-button{
        margin: 0;
        border-left: 1px solid #bbc2ce;
        border-top: 1px solid #bbc2ce;
        border-bottom: 1px solid #bbc2ce;
        border-right: none;
        border-radius: 0px;
        &--two-factor {
            height: 32px;
            padding: 0 12px;
            white-space: nowrap;
        }
        &:first-of-type{
            border-top-left-radius: 4px !important;
            border-bottom-left-radius: 4px !important;
        }
        &:last-of-type{
            border-right: 1px solid #bbc2ce;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }
}
</style>
